import { createContext, useContext } from 'react';

export interface ActiveGroupContextValue {
  /** undefined = no user choice yet; null = explicit cross-group/all view. */
  activeSlug: string | null | undefined;
  setActiveSlug: (slug: string | null) => void;
}

const defaultSetActiveSlug = (slug: string | null): void => {
  void slug;
};

export const ActiveGroupContext = createContext<ActiveGroupContextValue>({
  activeSlug: undefined,
  setActiveSlug: defaultSetActiveSlug,
});

export function useActiveGroup(): ActiveGroupContextValue {
  return useContext(ActiveGroupContext);
}
